<template>
  <div
    style="
      width: 512px;
      height: 384px;
      background: #000;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      transform-origin: top left;
      transform: scale(1, 0.5);
    "
  >
    <!-- transform: scale(1, 0.5); -->
    <div
      style="
        font-size: 130px;
        font-weight: bold;
        display: flex;
        align-items: center;
      "
      v-if="limit == 0"
    >
      <div style="display: flex; justify-content: center">
        <img
          src="@/assets/images/gif/temp.png"
          alt=""
          width="260"
          height="200"
          style="margin: 0 -70px"
        />
      </div>
      <div>
        {{ Number(raw_data.temperature.toFixed(1))
        }}<sup><span style="font-size: 0.7em"> °C</span></sup>
      </div>
    </div>
    <div
      style="
        font-size: 140px;
        font-weight: bold;
        display: flex;
        align-items: center;
      "
      v-if="limit == 1"
    >
      <div style="display: flex; justify-content: center">
        <img
          src="@/assets/images/gif/cloud_rain.gif"
          alt=""
          width="400"
          height="400"
          style="margin: -80px"
        />
      </div>
      <div>
        <span>{{ Math.floor(raw_data.humidity) }}</span>
        <span style="font-size: 0.5em">%</span>
      </div>
    </div>
    <div style="font-size: 140px" v-if="limit == 2">
      <div
        style="
          border: 10px solid;
          width: 350px;
          height: 350px;
          border-radius: 200px;
          padding: 30px;
          text-align: center;
          line-height: normal;
        "
        :style="{
          'border-color':
            raw_data.pm2_5 >= 0 && raw_data.pm2_5 <= 25
              ? '#2ACFF6'
              : raw_data.pm2_5 <= 37
              ? '#02DF00'
              : raw_data.pm2_5 <= 50
              ? '#FFF900'
              : raw_data.pm2_5 <= 90
              ? '#FFBF05'
              : '#E5150D',
        }"
      >
        <div style="font-size: 50px">PM 2.5</div>
        <div style="font-weight: bold">{{ raw_data.pm2_5 }}</div>
        <div style="font-size: 50px">µg./m<sup>3</sup></div>
      </div>
    </div>
    <div style="font-size: 125px" v-if="limit == 3">
      <div
        style="
          border: 10px solid;
          width: 350px;
          height: 350px;
          border-radius: 200px;
          display: flex;
          text-align: center;
          line-height: normal;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
        :style="{
          'border-color':
            raw_data.aqi >= 0 && raw_data.aqi <= 25
              ? '#2ACFF6'
              : raw_data.aqi <= 50
              ? '#02DF00'
              : raw_data.aqi <= 100
              ? '#FFF900'
              : raw_data.aqi <= 200
              ? '#FFBF05'
              : '#E5150D',
        }"
      >
        <div
          style="transform: scale(2, 1); display: flex; justify-content: center"
        >
          <div
            style="
              width: max-content;
              display: grid;
              grid-template-columns: min-content min-content min-content;
              gap: 10px;
              transform: rotateZ(-45deg);
              transformorigin: 50% 50%;
            "
          >
            <div
              :style="{
                ...dot,
                background:
                  raw_data.aqi >= 0 && raw_data.aqi <= 25
                    ? '#2ACFF6'
                    : raw_data.aqi <= 50
                    ? '#02DF00'
                    : raw_data.aqi <= 100
                    ? '#FFF900'
                    : raw_data.aqi <= 200
                    ? '#FFBF05'
                    : '#E5150D',
              }"
              v-for="i in 9"
              :key="i"
            ></div>
          </div>
        </div>
        <div style="font-weight: bold">{{ Number(raw_data.aqi) }}</div>
        <div style="font-size: 50px; font-weight: 500">AQI</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      raw_data: { humidity: 0, pm2_5: 0, temperature: 0, aqi: 0 },
      interval: null,
      timeout: null,
      limit: 0,
      dot: {
        height: "15px",
        width: "15px",
        "border-radius": "50%",
        display: "inline-block",
      },
    };
  },
  mounted() {
    this.getdata();

    this.interval = setInterval(() => {
      this.limit = this.limit >= 3 ? 0 : (this.limit += 1);
      //   console.log(this.limit);
    }, 1000 * 10);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  },
  methods: {
    async getdata() {
      try {
        let res = await this.$API.get("worth/getcurrent");
        console.log(res.data);
        this.raw_data = res.data.data;
        // const aqi = this.pm25_aqi(res.data.data.pm2_5)
        this.raw_data.aqi =
          res.data.data.aqi.length > 5
            ? res.data.data.aqi.slice(0, 5)
            : res.data.data.aqi;
        // console.log( this.raw_data);
      } catch (error) {
        console.error(error);
      }
      this.timeout = setTimeout(() => {
        this.getdata();
      }, 1000 * 5);
    },
    pm25_aqi(pm25) {
      const c = Math.floor(10 * pm25) / 10;
      const a =
        c < 0
          ? 0 // values below 0 are considered beyond AQI
          : c < 12.1
          ? lerp(0, 50, 0.0, 12.0, c)
          : c < 35.5
          ? lerp(51, 100, 12.1, 35.4, c)
          : c < 55.5
          ? lerp(101, 150, 35.5, 55.4, c)
          : c < 150.5
          ? lerp(151, 200, 55.5, 150.4, c)
          : c < 250.5
          ? lerp(201, 300, 150.5, 250.4, c)
          : c < 350.5
          ? lerp(301, 400, 250.5, 350.4, c)
          : c < 500.5
          ? lerp(401, 500, 350.5, 500.4, c)
          : 500; // values above 500 are considered beyond AQI
      return Math.round(a);
    },
  },
};
</script>

<style>
</style>